export { Person } from "./Person"
export { CurtainModal } from "./CurtainModal"
